/* eslint-disable import/no-cycle */
/**
 * @overview Search page refinement filters behaviour.
 *
 * @module search/refinements
 */

import $ from 'qwery';
import { filterRestaurants, setActiveItems } from './filtering';


/**
 * Enable a single refinement filter.
 *
 * @param {Node} filter - The filter to be enabled.
 */
function enableFilter (filter) {
    filter.querySelector('input').disabled = false;
    filter.classList.remove('is-inactive');
}

/**
 * Disable a single refinement filter.
 *
 * @param {Node} filter - The filter to be disabled.
 */
function disableFilter (filter) {
    filter.querySelector('input').disabled = true;
    filter.classList.add('is-inactive');
}

/**
 * Update the refinement filters.
 *
 * @param {string[]} disabledFilters - List of filters which should be disabled.
 */
export function updateRefinements (disabledFilters) {
    if (disabledFilters) {
        const refinements = $('[data-refine-by]');

        refinements.forEach(refinement => {
            const shouldDisableRefinement = disabledFilters.indexOf(refinement.getAttribute('data-refine-by')) > -1;

            if (shouldDisableRefinement) {
                disableFilter(refinement);
            } else {
                enableFilter(refinement);
            }
        });

        setActiveItems(refinements);
    }
}

/**
 * Bind refinement events.
 *
 * @param {Node} input - Refinement input element.
 */
function bindEvents (input) {
    input.addEventListener('change', e => {
        e.preventDefault();

        filterRestaurants();
    });
}

(function initRefinements () {
    let refinements = $('.control-input', '[data-refinements]');
    if (refinements.length > 0) {
        const orderTypeRefinements = $('.control-input', '[data-ordertype-refinements]');
        if (orderTypeRefinements.length > 0) {
            refinements = refinements.concat(orderTypeRefinements);
        }
        refinements.forEach(bindEvents);
    }
}());
